import CryptoJS from 'crypto-js';

const key = CryptoJS.enc.Utf8.parse("Agriculture.encr".padEnd(16, "\0")); // 补足16字节
export function decrypt(ciphertext: string): string {
  try {
    // 清理Base64密文并补全可能缺失的等号
    ciphertext = ciphertext.replace(/[\s\r\n]+/g, "");
    const missingPadding = ciphertext.length % 4;
    if (missingPadding) {
      ciphertext += '='.repeat(4 - missingPadding);
    }
    
    // 处理可能的URL安全Base64编码
    ciphertext = ciphertext.replace(/-/g, '+').replace(/_/g, '/');
    
    const decrypted = CryptoJS.AES.decrypt(
      ciphertext,
      key,
      { 
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      }
    );
    
    // 尝试多种解码方式
    try {
      return decrypted.toString(CryptoJS.enc.Utf8);
    } catch (e) {
      try {
        return decrypted.toString(CryptoJS.enc.Latin1);
      } catch (e) {
        const hexStr = CryptoJS.enc.Hex.stringify(decrypted);
        return hexToUtf8(hexStr); // 需要实现hexToUtf8函数
      }
    }
  } catch (error) {
    console.error("解密失败:", error);
    throw new Error("解密失败，请检查密钥或密文格式");
  }
}

// Hex转UTF-8工具函数
function hexToUtf8(hexStr: string): string {
  try {
    return decodeURIComponent('%' + hexStr.match(/.{1,2}/g)?.join('%'));
  } catch (e) {
    return hexStr; // 如果转换失败，返回原始Hex字符串
  }
}